import type { CSSProperties } from "react";
import { Link } from "react-router-dom";
import { Badge, Button } from "@pilot-protocol/ui";

export default function NotFoundPage() {
  return (
    <div style={pageStyle}>
      <Badge variant="destructive">404</Badge>
      <h1 style={titleStyle}>Route not found</h1>
      <p style={leadStyle}>The URL you opened isn't a public surface.</p>
      <Link to="/" style={{ textDecoration: "none" }}>
        <Button variant="outline">Back to landing</Button>
      </Link>
    </div>
  );
}

const pageStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 12,
  alignItems: "flex-start",
};

const titleStyle: CSSProperties = {
  margin: 0,
  fontSize: "var(--text-3xl)",
  fontFamily: "var(--font-display)",
};

const leadStyle: CSSProperties = {
  margin: 0,
  color: "var(--foreground-secondary)",
};
